import React from 'react';

// ISO Globe Logo Component
const ISOLogo = ({ standard, year }) => (
  <svg viewBox="0 0 120 100" className="w-24 h-20">
    {/* Globe with grid lines */}
    <g fill="none" stroke="#1e40af" strokeWidth="1.5">
      {/* Outer circle */}
      <ellipse cx="60" cy="40" rx="35" ry="35" />
      {/* Horizontal lines */}
      <ellipse cx="60" cy="40" rx="35" ry="12" />
      <ellipse cx="60" cy="40" rx="35" ry="25" />
      {/* Vertical lines */}
      <ellipse cx="60" cy="40" rx="12" ry="35" />
      <ellipse cx="60" cy="40" rx="25" ry="35" />
      {/* Center vertical */}
      <line x1="60" y1="5" x2="60" y2="75" />
      {/* Center horizontal */}
      <line x1="25" y1="40" x2="95" y2="40" />
    </g>
    {/* ISO Text */}
    <text x="60" y="48" textAnchor="middle" fill="#1e40af" fontSize="22" fontWeight="bold" fontFamily="Arial, sans-serif">
      ISO
    </text>
    {/* Standard number */}
    <text x="60" y="90" textAnchor="middle" fill="#1e40af" fontSize="14" fontWeight="600" fontFamily="Arial, sans-serif">
      {standard}{year ? `:${year}` : ''}
    </text>
  </svg>
);

const CertificationsSection = () => {
  const certifications = [
    { standard: '9001', year: '2015', name: 'Quality Management', desc: 'International quality standards' },
    { standard: '14001', year: '2015', name: 'Environmental', desc: 'Environmental management' },
    { standard: '27001', year: null, name: 'Information Security', desc: 'Data protection standards' },
    { standard: '45001', year: '2018', name: 'Health & Safety', desc: 'Occupational safety' },
  ];

  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#4fd1c5] text-sm font-semibold tracking-[0.15em] uppercase mb-3">
            Certified
          </p>
          <h2 className="text-3xl lg:text-4xl font-light text-[#0a1628]">
            Our Commitment to <span className="font-semibold">Excellence</span>
          </h2>
        </div>

        {/* Certifications Grid */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {certifications.map((cert, i) => (
            <div 
              key={i} 
              className="group p-8 bg-[#f8fafc] hover:bg-white hover:shadow-lg transition-all duration-500 ease-out text-center border border-transparent hover:border-gray-200"
            >
              <div className="flex justify-center mb-5 transition-transform duration-500 ease-out group-hover:scale-105">
                <ISOLogo standard={cert.standard} year={cert.year} />
              </div>
              <h3 className="text-lg font-semibold text-[#0a1628] mb-2 transition-colors duration-300">
                {cert.name}
              </h3>
              <p className="text-sm text-gray-500 transition-colors duration-300">
                {cert.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Trust Text */}
        <div className="mt-12 text-center">
          <p className="text-gray-500">
            Trusted by Fortune 500 companies and leading enterprises across the GCC region
          </p>
        </div>
      </div>
    </section>
  );
};

export default CertificationsSection;
